import { render, staticRenderFns } from "./NovaPoshtaShow.vue?vue&type=template&id=d75572fa&scoped=true"
import script from "./NovaPoshtaShow.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaShow.vue?vue&type=script&lang=js"
import style0 from "./NovaPoshtaShow.vue?vue&type=style&index=0&id=d75572fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75572fa",
  null
  
)

export default component.exports